module.exports = __webpack_public_path__ + "img/icon_person.05315b79.svg";